import { useMutation } from '@apollo/client';
import { deleteVisitorWatchlist } from 'graphql-queries';

export function useDeleteVisitorWatchlist() {
  const [deleteWatchlist, { loading }] = useMutation(deleteVisitorWatchlist, {
    onError: error => {
      console.error('Error deleting watchlist:', error);

      throw error;
    },
  });

  const handleDelete = async (
    visitorWatchlistId: string,
    organizationId: string,
    onSuccess?: () => void
  ) => {
    if (!organizationId) {
      throw new Error('Organization ID is required');
    }

    await deleteWatchlist({
      variables: {
        visitorWatchlistId,
        organizationId,
      },
    });

    if (onSuccess) {
      onSuccess();
    }
  };

  return {
    deleteWatchlist: handleDelete,
    loading,
  };
}
